import { eAudioAsset, Game, rnd2 } from "../../Game";
import { AudioManager } from "../../Utils/AudioManager";
import { eGameplayState, Gameplay, TIMER } from "../Gameplay";
import { eRoundMngState, RoundManager } from "../Round/RoundManager";

const enum eChantingState {
    silence,
    chanting,
    chantingStart,
    chantingEnd
}



export class ChantingSfxManager {
    private static readonly CHANTING_MIN_LEN = 7500;
    private static readonly CHANTING_MAX_LEN = 12000;

    private static readonly CHANTING_MIN_SPACING = 7500;
    private static readonly CHANTING_MAX_SPACING = 15000;

    static readonly SFX_VER_CNT = 2;

    private _state: number;
    private _time: number;
    private _soundInstance: pc.SoundInstance;
    private _soundVer: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._soundVer = -1;

        Game.audio.on(AudioManager.EVENT_STOP, this.handleAudioMngStop, this);
        Game.audio.on(AudioManager.EVENT_MUTE_CHANGED, this.handleAudioMngMuteChanged, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this._soundInstance) {
            this._soundInstance.stop();
            this._soundInstance = undefined;
        }

        this._state = eChantingState.silence;
        this._time = TIMER.time + rnd2.randomIntIn(ChantingSfxManager.CHANTING_MIN_SPACING, ChantingSfxManager.CHANTING_MAX_SPACING);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (Game.audio.isMuted && Gameplay.instance.state <= eGameplayState.gameOverMessage)
            return;

        switch (this._state) {
            case eChantingState.silence: {
                if (TIMER.time > this._time && RoundManager.instance.state == eRoundMngState.playRound) {
                    // Spustit skandovani
                    let ent = Game.app.root;
                    let ver = rnd2.randomIntIn(0, ChantingSfxManager.SFX_VER_CNT - 1);

                    if (ver == this._soundVer && ver-- == 0)
                        ver = ChantingSfxManager.SFX_VER_CNT - 1;

                    if (!ent.sound.slots[eAudioAsset.chantLoop + ver]) {
                        ent.sound.addSlot(eAudioAsset.chantLoop + ver, {
                            loop: true,
                            autoPlay: false,
                            volume: 0.8,
                            asset: Game.app.assets.find(eAudioAsset.chantLoop + ver, pc.eAssetType.audio).id
                        });
                    }

                    ent.sound.stop(eAudioAsset.chantLoop + ver);

                    this._soundInstance = Game.audio.playSound(ent, eAudioAsset.chantLoop + ver);
                    this._soundInstance.volume = 0;
                    this._soundInstance.loop = true;
                    this._soundVer = ver;
                    this._state = eChantingState.chantingStart;
                    this._time = TIMER.time;
                }

                break;
            }
            case eChantingState.chanting: {
                if (TIMER.time >= this._time) {
                    // Zahajit snizovani hlasitosti
                    this._state = eChantingState.chantingEnd;
                    this._time = TIMER.time;
                }

                break;
            }
            case eChantingState.chantingStart: {
                // Postupne zvedat hlasitost
                let i = (TIMER.time - this._time) / 1500;

                if (i >= 1) {
                    i = 1;
                    this._state = eChantingState.chanting;
                    this._time = TIMER.time + rnd2.randomIntIn(ChantingSfxManager.CHANTING_MIN_LEN, ChantingSfxManager.CHANTING_MAX_LEN);
                }

                this._soundInstance.volume = i;

                break;
            }
            case eChantingState.chantingEnd: {
                let i = (TIMER.time - this._time) / 2000;

                if (i >= 1) {
                    this.reset();
                }
                else {
                    this._soundInstance.volume = 1 - i;
                }

                break;
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAudioMngStop(): void {
        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAudioMngMuteChanged(audioMng: AudioManager, muted: boolean): void {
        // Pokud doslo k obnoveni zvuku ve hre, tak resetovat stav spravce
        if (!muted)
            this.reset();
    }
}